import styled from 'styled-components';
import { colors } from '../colors';

interface tabsNavLinkProps {
	active?: boolean;
}

const TabsNavLink = styled.li<tabsNavLinkProps>`
	margin: 15px 12px 0 0;
	list-style: none;
	font-size: 14px;
	line-height: 17px;
	min-height: 40px;
	padding: 0px 24px;
	cursor: pointer;
	transition: ease-in all 0.4s;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${colors.Grey58};
	@media screen and (max-width: 600px) {
		padding: 0px;
		margin: 7px 0 0 0;
	}
	&:after {
		transition: ease-in all 0.4s;
		width: 0px;
		height: 3px;
		content: '';
		position: absolute;
		bottom: 0;
		background: ${colors.BlueDark};
	}
	:hover {
		color: ${colors.BlueBase};
		&:after {
			width: 100%;
		}
	}
	${({ active }) =>
		active &&
		`color: ${colors.Black};
		&:after{
			width: 100%;
		}
	`}
`;

export default TabsNavLink;
